<div class="location-container">
  <div class="search-button">
    <app-button
      appearance="outlined"
      (click)="processGeoLocation()"
      [attr.data-qa-id]="'filterLocationGeolocation' + filterId()"
      data-testid="geolocation-button"
    >
      <mat-icon class="material-icons-outlined">location_on</mat-icon>
      <span i18n="@@zip-code-filter.geolocation-button.label">Search near me</span>
    </app-button>
  </div>
  <div class="zipcode">
    <mat-form-field class="hide-subscript" appearance="outline">
      <mat-label i18n="@@zip-code-filter.zip-code-label">Zip Code</mat-label>
      <input
        [attr.data-qa-id]="'filterLocationZipCode' + filterId()"
        matInput
        type="text"
        pattern="[a-zA-Z0-9]{5}"
        [value]="state().type === 'zipcode' ? state().value : ''"
        (change)="onZipCodeChanged($event)"
        data-testid="zipcode-input"
      />
    </mat-form-field>
  </div>
  <div class="miles">
    <span class="within" i18n="@@zip-code-filter.within-label">Within</span>
    <span class="selector">
      <mat-form-field class="select-outlined hide-subscript" appearance="outline">
        <mat-select
          [value]="state().miles"
          (selectionChange)="onMilesChanged($event)"
          [attr.data-qa-id]="'filterLocationMiles' + filterId()"
          data-testid="miles-select"
        >
          <mat-option [value]="50" i18n="@@zip-code-filter.miles-option.50">50 Miles</mat-option>
          <mat-option [value]="100" i18n="@@zip-code-filter.miles-option.100">100 Miles</mat-option>
          <mat-option [value]="200" i18n="@@zip-code-filter.miles-option.200">200 Miles</mat-option>
          <mat-option [value]="250" i18n="@@zip-code-filter.miles-option.250">250 Miles</mat-option>
          <mat-option [value]="500" i18n="@@zip-code-filter.miles-option.500">500 Miles</mat-option>
        </mat-select>
      </mat-form-field>
    </span>
  </div>
</div>
